$("#changePasswordForm button").on("click", function (e) {
    let inputBlock = $("#changePasswordInput");
    let inputs = $("input", inputBlock);
    if (inputBlock.is(":visible")) {
        if (inputs[1].value === inputs[2].value) {
            return true;
        } else {
            $(".alert-danger", inputBlock).show();
        }
    } else {
        inputBlock.show('fast');
        $(inputs[0]).focus();
    }

    e.preventDefault();
});